import styled from 'styled-components';
import { cloneDeep } from 'lodash';

const getAccessor = (col) => {
  switch (col) {
    default:
      return col.name;
  }
};

const getType = (col) => {
  switch (col.name) {
    case 'title':
      return 'HTML';
    case 'estimatedTime':
      return 'Timer';
    case 'scheduledStartDate':
    case 'dueDate':
      // return 'Text';
      return 'DateTime';
    // case 'displayId':
    //   return 'TaskId';
    case 'status':
      return 'Status';
    case 'priority':
      return 'Priority';
    case 'source':
      return 'Source';
    case 'technician':
      return 'Technician';
    default:
      return 'Text';
  }
};

const isEditable = (col) => {
  switch (col.name) {
    case 'priority':
      return true;
    default:
      return false;
  }
};

const isSortable = (col, availableAttributes) => {
  if (availableAttributes.indexOf(col.name) > -1) return true;
  switch (col.name) {
    case 'source':
    case 'workItem.client':
    case 'workItem.site':
      return true;
    default:
      return false;
  }
};

const isFilterable = (col) => {
  switch (col.name) {
    case 'estimatedTime':
      return false;
    default:
      return true;
  }
};

const getVariables = (property) => {
  switch (property.name) {
    case 'client':
      return { listInfo: {} };
    default:
      return null;
  }
};

const getFields = (personalizedColumns) => {
  let fields = personalizedColumns;
  let fieldsToRequest = [
    {
      listInfo: [
        'page',
        'pageSize',
        'hasMore',
        'totalCount',
        {
          sort: ['attribute', 'order']
        }
      ]
    }
  ];
  let allFields = [];
  fields.forEach((el) => {
    switch (el.name) {
      case 'techGroup':
        allFields.push({
          techGroup: ['groupId', 'name']
        });
        break;
      case 'technician':
        allFields.push({
          technician: ['userId', 'email', 'firstName', 'lastName', 'name']
        });
        break;
      default:
        allFields.push(el.name);
    }
  });
  allFields = allFields.concat([
    'taskId',
    'description',
    {
      ticket: [
        'ticketId',
        'subject',
        'displayId',
        { loggedInUserAsFollower: ['ticketPermission'] }
      ]
    },
    { project: ['projectId', 'title', { loggedInUserRole: ['roleId'] }] },
    'ticketPermission',
    'module'
  ]);
  fieldsToRequest.push({
    tasks: allFields
  });
  return fieldsToRequest;
};

const dependencyMap = {
  subcause: 'cause',
  subcategory: 'category',
  technician: 'techGroup'
};

const isDependantField = (field) => {
  return Object.keys(dependencyMap).indexOf(field) > -1;
};

const getParentField = (child) => {
  return dependencyMap[child];
};

const getDependantField = (parent) => {
  return Object.keys(dependencyMap).find(
    (key) => dependencyMap[key] === parent
  );
};

const DisabledTag = styled.div`
  opacity: 0.5;
`;
const CellWrapper = styled.div`
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  .Polaris-Link {
    width: 100%;
  }
`;

const conditionMap = {
  3: {
    joinOperator: 'AND',
    operands: [
      {
        attribute: 'technician',
        operatorValue: 'placeholder.is.loggedin.user'
      }
    ]
  },
  4: {
    condition: {
      joinOperator: 'AND',
      operands: [
        {
          attribute: 'techGroup',
          operatorValue: 'placeholder.in.loggedin.techgroup'
        }
      ]
    }
  }
};

const checkDynamicQuery = (f) => {
  if (f.isCustom) return true;
  switch (f.name) {
    case 'technician':
    case 'subcategory':
    case 'subcause':
      return true;
    default:
      return false;
  }
};

const getAttributeName = (column) => {
  if (column?.name) {
    switch (column.name) {
      case 'prioritizedId':
        return 'displayId';
      case 'requester':
        return 'requester.name';
      case 'technician':
        return 'technician.name';
      case 'techGroup':
        return 'techGroup.name';
      case 'firstResponseTimer':
        return 'firstResponseDueTime';
      case 'resolutionTimer':
        return 'resolutionDueTime';
      case 'sla':
        return 'sla.name';
      case 'source':
      case 'workItem.client':
      case 'workItem.site':
        return column?.attributeName;
      default:
        return column.name;
    }
  }
};

const getRuleAttribute = (f) => {
  switch (f.name) {
    case 'source':
    case 'workItem.site':
    case 'workItem.client':
      return f?.attributeName;
    case 'technician':
      return 'technician.name';
    case 'techGroup':
      return 'techGroup.name';
    default:
      return f.name;
  }
};

const getDefaultValue = (f, condition) => {
  const operands = cloneDeep(condition.operands);
  const ruleIdx = operands.findIndex((el) => {
    if (f.dataType === 'entity') {
      return el.attribute === `${f.name}.name`;
    }
    return el.attribute === getRuleAttribute(f);
  });
  if (ruleIdx > -1) {
    const rule = operands[ruleIdx];
    switch (f.dataType) {
      case 'date':
      case 'datetime':
      case 'daterange':
        return rule.value;
      default:
        break;
    }
    switch (f.filterType) {
      case 'text':
      case 'numeric':
      case 'decimal':
      case 'paragraph':
      case 'read_only':
        console.log(rule, 'ash:: rule');
        return rule.value;
      default:
        return rule.value.map((el) => {
          return {
            name: el,
            value: el,
            label: el
          };
        });
    }
  }
  return '';
};

const defaultColumnOrder = [
  'displayId',
  'title',
  'estimatedTime',
  'status',
  'priority',
  'technician',
  'source',
  'workItem.client',
  'workItem.site',
  'techGroup',
  'scheduledStartDate',
  'dueDate'
];

const checkCustomAttribute = (attr, field) => {
  return attr === getRuleAttribute(field);
};

const updateConditions = (params) => {
  const { condition, selectedField, viewConditions, setConditions } = params;
  if (condition?.operands?.length) {
    const currentConditions = cloneDeep(viewConditions) || {
      joinOperator: 'AND',
      operands: []
    };
    let updatedCondition = {};
    const ruleIdx = currentConditions.operands.findIndex((el) =>
      selectedField.dataType === 'entity'
        ? el.attribute === `${selectedField.name}.name`
        : el.attribute === getRuleAttribute(selectedField)
    );

    if (ruleIdx > -1) {
      currentConditions.operands[ruleIdx] = condition.operands[0];
      updatedCondition = currentConditions;
    } else {
      updatedCondition = {
        ...currentConditions,
        operands: currentConditions.operands.concat(condition.operands)
      };
    }
    setConditions(updatedCondition);
  } else {
    const currentConditions = cloneDeep(viewConditions);
    if (currentConditions) {
      const ruleIdx = currentConditions.operands.findIndex((el) =>
        selectedField.dataType === 'entity'
          ? el.attribute === `${selectedField.name}.name`
          : el.attribute === getRuleAttribute(selectedField)
      );
      if (ruleIdx > -1) {
        currentConditions.operands.splice(ruleIdx, 1);
        setConditions(
          currentConditions?.operands?.length
            ? {
                ...currentConditions,
                operands: currentConditions.operands
              }
            : null
        );
      }
    }
  }
};

export {
  getAccessor,
  getType,
  isEditable,
  isSortable,
  isFilterable,
  getFields,
  getVariables,
  DisabledTag,
  dependencyMap,
  getDependantField,
  getParentField,
  isDependantField,
  CellWrapper,
  conditionMap,
  checkDynamicQuery,
  getAttributeName,
  getDefaultValue,
  defaultColumnOrder,
  checkCustomAttribute,
  updateConditions
};
